import React, { Component } from "react";
import InsetGallery from '../global/InsetGallery';

export default class PageInsetGallery extends Component {
  	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--text-space c-page__block--top-' + block.top_space + ' c-page__block--bottom-' + block.bottom_space + ' scope-' + block.background_colour}>
			    
			    	<div className="c-page__block__inner">
			    			    		
		    			<InsetGallery gallery={block.gallery} controls={block.show_controls}></InsetGallery>
		    			
		    		</div>
			    					    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
